var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 147,
    viewBox: "0 0 77 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M38.0822 30.7198C45.2502 30.7198 51.061 24.8861 51.061 17.69C51.061 10.4938 45.2502 4.66016 38.0822 4.66016C30.9142 4.66016 25.1034 10.4938 25.1034 17.69C25.1034 24.8861 30.9142 30.7198 38.0822 30.7198Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    d: "M31.1565 146.684L28.557 108.471C28.557 108.471 30.2838 103.252 21.6313 103.699C13.4058 104.575 8.22546 104.575 8.22546 104.575C8.22546 104.575 20.7772 83.7348 22.931 54.6181C22.504 48.0939 23.8037 40.2835 36.3369 40.7122L48.0159 41.141C48.0159 41.141 56.6684 40.2648 57.0955 55.9043C58.3952 65.0196 63.1485 90.2217 69.6472 102.823L58.3952 103.699C58.3952 103.699 52.7692 102.394 52.3422 109.347C51.9151 116.3 51.4695 145.398 51.4695 145.398"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.cacb61ac7321af28def702f7cbaab367.svg";
export { ForwardRef as ReactComponent };